import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { useSupplierSelectSearch } from '@/hooks/useSupplierSelectSearch';
import type { SupplierResponse } from '@/types/supplier';
import { useSelectLabels } from '@/hooks/useSelectLabels';

export interface SupplierSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onSupplierChange?: (supplier: SupplierResponse | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  name?: string;
}

export function SupplierSelect({
  label = 'Supplier',
  value = '',
  onChange,
  onSupplierChange,
  placeholder,
  disabled,
  className,
  required,
  error,
  name,
}: SupplierSelectProps) {
  const selectLabels = useSelectLabels();
  const { options, loading, searching, onSearchQuery, getSupplier } = useSupplierSelectSearch({ value });

  const handleChange = (next: string) => {
    onChange?.(next);
    onSupplierChange?.(next ? getSupplier(next) ?? null : null);
  };

  return (
    <SearchableSelect
      label={label}
      name={name}
      required={required}
      error={error}
      value={value}
      onChange={handleChange}
      options={options}
      placeholder={placeholder ?? selectLabels.selectSupplier}
      disabled={disabled}
      loading={loading}
      searching={searching}
      className={className}
      searchPlaceholder={selectLabels.searchSuppliersDetail}
      emptyMessage={selectLabels.noSuppliers}
      filterLocally={false}
      onSearchQuery={onSearchQuery}
    />
  );
}
